import { render } from "./CopyToClipboard.vue?vue&type=template&id=4c9d86ba"
const script = {}
script.render = render

export default script